import React, {useState} from "react";
import SDInput from "./sdInput";
import SDBtn from "./sdBtn";
import SDRadioGroup from "./sdRadioGroup";
import './sdFinance.scss';
import { AddFinance, DeleteFinance } from '../api';
import SDRadio from "./sdRadio";
import SDSwitch from "./sdSwitch";
import ioIcon from './img/io.png';
import delIcon from './img/delete.png';

function SDFinance (props) {
  const [showSetting, setShowSetting] = useState(false);
  const [spend, setSpend] = useState(0);
  const [desc, setDesc] = useState('');
  const [fType, setFtype] = useState('');
  const [io, setIO] = useState('');
  const [value, setValue] = useState(0);
  const ftype = ['食','衣','住','行','育','樂','醫'];

  //console.log(props.data);
  function click () {
    setShowSetting(true);
  }

  function clickMask (e) {
    if (e.target.className == 'finmask') {
      setShowSetting(false);
      return;
    }
  }

  function selectType (e) {
    setFtype(ftype[e]);
  }

  function clickAdd() {
    setShowSetting(false);
    //console.log(`${props.year}-${props.month}-${props.day}`);
    
    let data = {
      Type: fType,
      IO: io ? 'in': 'out',
      Description: desc,
      Value: value,
      Year: props.year,
      Month: props.month,
      Day: props.day
    };

    if (!fType || !desc || value === 0) {
      return;
    }
    
    AddFinance(data).then(res => {
      //console.log(res);
    });
  }

  function setCIO(e) {
    setIO(e);
  }

  function deleteIO (e) {
    DeleteFinance({
      data: {
      FinanceID: e.financeID
      }
    }).then(res => {
      console.log(res);
    })
  }

  let sum = 0;

  if (props.data && props.data.length > 0) {
    //console.log(props.data);
    sum = props.data
      .filter(o => o.io == 'out')
      .map(obj => obj.value)
      .reduce((accumulator, current) => accumulator + current, 0);
  }

  return (
    <div className="sdFinance">
      <div className="nowSpend">{sum}</div>
      <div className="icon" style={{backgroundImage: `url(${ioIcon})`}} onClick={() => click()}></div>
      {
        showSetting ?
        <div className="finmask" onClick={e => clickMask(e)}>
          <div className="settingBlock">
            <div className="fDate">{`${props.year}-${props.month + 1}-${props.day}`}</div>
            <div><SDInput label="名目" change={e => setDesc(e)}></SDInput></div>
            <div className="typeGroup">
                <SDRadioGroup label={'類別'} data={ftype} onSelect={e => selectType(e)}></SDRadioGroup>
            </div>
            <div className="ioGroup">
              <div>支出</div>
              <SDSwitch onSet={e => setCIO(e)}></SDSwitch>
              <div>收入</div>
            </div>
            <div><SDInput label="金額" change={e => setValue(e)}></SDInput></div>
            <div className="submitF"><SDBtn label="添加" click={() => clickAdd()} ></SDBtn></div>
            <div className="fhis">
              <div>當日開銷</div>
            {
              props.data && props.data.length > 0 ?
                props.data.map(d => {
                  return <div className="finHis" key={d.financeID}>
                    <div>{d.description}</div>
                    <div>{d.io == 'out' ? '支出' : '收入'}</div>
                    <div>{d.type}</div>
                    <div>{d.value}</div>
                    <div className="deletef" onClick={() => deleteIO(d)} style={{backgroundImage: `url(${delIcon})`}}></div>
                  </div>
                })
              : ''
            }
            </div>
          </div>
        </div>
        : ''
      }
    </div>
  )
}

export default SDFinance;